import React from "react";
import { configs } from "./config";

export const courtConnectContext = {
  theme: {
    colors: {
      primary: "#009ca6",
      secondary: "#7b57cb",
      tertiary: "#d62598",
      warning: "#ff8a3d",
      danger: "#cd425b"
    }
  },
  api: {
    baseUrl: configs.apiBaseUrl
  }
};

export const CourtConnectContext = React.createContext(courtConnectContext);
